module.exports = __webpack_public_path__ + "static/coach-hire-services-day-at-races-2f7189f93d5794fc91f206f482c79e21.jpg";